export default {
  List: {
    Title: 'Báo cáo tài chính',
  },
  Param: {
    OrganizationCodePlaceholder: 'Nhập mã đơn vị đăng ký với hệ thống TKT của Kho bạc Nhà nước',
  },
  Detail: {
    OrganizationCode: 'Mã đơn vị',
    OrganizationName: 'Tên đơn vị',
    Tab: {
      ErrorList: 'Danh sách lỗi',
      B01: 'B01-X',
      C03: 'C03/CCTT',
      Comparison: 'Đối chiếu',
    },
    Btn: {
      GetDefault: 'Lấy lại mặc định',
      ImportDataFromXML: 'Nhập khẩu số liệu đầu năm từ TKT',
      GetDataFromQLTS: 'Lấy dữ liệu từ MISA QLTS',
    },
    ReportTitle: {
      C03: 'BÁO CÁO VỀ CUNG CẤP THÔNG TIN TÀI CHÍNH',
    },
    GridTitle: {
      B01: {
        AdditionalInfo01: 'Thông tin bổ sung cho phần I. Tình hình tài chính',
        AdditionalInfo02: 'Thông tin bổ sung cho phần II. Kết quả hoạt động',
      },
    },
    Unit: 'Đơn vị tính: ',
    MenuItem: {
      B01: {
        FinancialSituation: 'Tình hình tài chính',
        ActivitieResult: 'Kết quả hoạt động xã',
        CashFlow: 'Lưu chuyển tiền',
        Demonstration: 'Thuyết minh',
        AdditionalInfo01: 'Thông tin bổ sung cho phần 1 - Tình hình tài chính',
        AdditionalInfo02: 'Thông tin bổ sung cho phần 2 - Kết quả hoạt động',
        Money: 'Tiền',
        OtherIncomes: 'Các khoản phải thu khác',
        Inventory: 'Hàng tồn kho',
        FixedAsset: 'Tài sản cố định',
        ConstructionInProgress: 'Xây dựng cơ bản dở dang',
        Debt: 'Nợ phải trả',
        FundOutsideBudgets: 'Các quỹ ngoài ngân sách xã',
      },
      C03: {
        Data: 'Số liệu',
        VisibleFixedAsset: 'Tài sản cố định hữu hình trang bị cho đơn vị',
        InvisibleFixedAsset: 'Tài sản cố định vô hình trang bị cho đơn vị',
        ReviewAnalysis: 'Phân tích, đánh giá',
      },
    },
    GetDataFromQLTSWarning: {
      Title: 'Đã ngắt kết nối với MISA QLTS',
      Body: 'Vui lòng kết nối với phần mềm MISA QLTS để lấy dữ liệu lên báo cáo C03/CCTT. Bạn có muốn thực hiện kết nối với MISA QLTS không?',
    },
  },
  PopupParam: {
    Title: 'Tham số báo cáo',
    Label: {
      ReportingPeriod: 'Kỳ báo cáo',
      Year: 'Năm',
      FoundingDate: 'Ngày lập',
      Founder: 'Người lập',
      Controller: 'Người kiểm soát',
      UnitHeads: 'Thủ trưởng đơn vị',
    },
  },
  ErrorTitle: '* Bắt buộc phải sửa những lỗi nghiệp vụ trước khi cất',
};
